import { AppTranslationPipe } from '@adapter/i18n/app-translation.pipe';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  signal
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-input-time',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FloatLabelModule,
    DatePickerModule,
    AppTranslationPipe
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppInputTimeComponent),
      multi: true
    }
  ],
  template: `
    <p-floatLabel>
      <p-datepicker
        [inputId]="id()"
        [iconDisplay]="'input'"
        [showIcon]="true"
        [timeOnly]="true"
        [minDate]="min()"
        [maxDate]="max()"
        styleClass="w-full"
        appendTo="body"
        [disabled]="isDisabled()"
        [(ngModel)]="value"
        (ngModelChange)="updateValue($event)"
      >
        <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
          <i
            class="pi pi-clock"
            (keyup)="clickCallBack($event)"
            (click)="clickCallBack($event)"
            tabindex="0"
          ></i>
        </ng-template>
      </p-datepicker>
      <label for="{{ id() }}">{{ label() | translate }}</label>
    </p-floatLabel>
  `,
  styles: ``
})
export class AppInputTimeComponent implements ControlValueAccessor {
  /**
   * Identificador del input
   */
  id = input.required<string>();

  /**
   * Etiqueta del input
   */
  label = input.required<string>();

  /**
   * Valor mínimo del input
   */
  min = input<Date>();

  /**
   * Valor máximo del input
   */
  max = input<Date>();

  /**
   * Valor del input
   */
  value = signal<Date | undefined>(undefined);

  /**
   * Indica si el input está deshabilitado
   */
  isDisabled = signal(false);

  onChange?: (value: Date) => void;

  onTouched?: () => void;

  writeValue(value: Date): void {
    this.value.set(value);
  }

  registerOnChange(fn: (value: Date) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }

  updateValue(event: Date): void {
    this.value.set(event);
    this.onChange!(event);
    this.onTouched!();
  }
}
